export default {
    'memberBenefit.title': '會員權益',
} as Record<string, string>;
